'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildConversation = buildConversation;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _Conversation = require('../../records/Conversation');

var _Conversation2 = _interopRequireDefault(_Conversation);

var _Visitor = require('../../records/Visitor');

var _Visitor2 = _interopRequireDefault(_Visitor);

var _LatestEmailMessage = require('../../records/LatestEmailMessage');

var _LatestEmailMessage2 = _interopRequireDefault(_LatestEmailMessage);

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _propertyValues = require('../../lib/propertyValues');

var _ConversationStatusTypes = require('../../constants/ConversationStatusTypes');

var _ConversationStatusTypes2 = _interopRequireDefault(_ConversationStatusTypes);

var _buildLatestMessage = require('./buildLatestMessage');

var _buildLatestMessage2 = _interopRequireDefault(_buildLatestMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Build a Conversation record from an JavaScript or Immutable object.
 *
 * @param {Object|Map|Conversation} [props={}] - Properties to build the conversation from
 * @return {Conversation}
 *
 */
function buildConversation() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      props = _objectWithoutProperties(_ref, []);

  return (0, _pipe2.default)((0, _propertyValues.setDefaultValues)({
    portalId: _hubspot2.default.get(),
    status: _ConversationStatusTypes2.default.STARTED
  }), (0, _propertyValues.enforceValues)({
    latestEmailMessage: (0, _LatestEmailMessage2.default)((0, _get2.default)('latestEmailMessage', props)),
    latestMessage: (0, _buildLatestMessage2.default)((0, _get2.default)('latestMessage', props), (0, _get2.default)('channel', props), (0, _get2.default)('threadId', props)),
    visitor: (0, _Visitor2.default)((0, _get2.default)('visitor', props)),
    unseenCount: (0, _get2.default)('unseenCount', props) || 0
  }), _Conversation2.default)(props);
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/factories/ConversationFactory/buildConversation.js
// module id = 78
// module chunks = 2 3